/** @jsx jsx */
import { Styled, jsx } from 'theme-ui'
import { Link } from 'gatsby'
//

const Breadcrumb = ({ items = null }) => {
  if (!items?.length) {
    return null
  }

  const handleClick = (e, { action }) => {
    if (action) {
      e.preventDefault()
      action()
    }
  }

  return (
    <Styled.div sx={{ display: 'flex', pl: 1, mb: 2 }}>
      {items.map((item, idx) => (
        <Styled.div key={`item-${item?.slug}-${idx}`} sx={{ pr: 2 }}>
          {item.slug ? (
            <Link
              sx={{
                color: 'text',
                textDecoration: 'none',
                borderBottomWidth: '1px',
                borderBottomColor: 'text',
                borderBottomStyle: 'solid'
              }}
              to={item.slug}
              onClick={e => handleClick(e, item)}
            >
              {item.label}
            </Link>
          ) : (
            <span sx={{ fontSize: '.875rem' }}>{item.label}</span>
          )}
          {item.slug ? <span sx={{ ml: '5px' }}>▸</span> : null}
        </Styled.div>
      ))}
    </Styled.div>
  )
}

export default Breadcrumb
